import { Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';

import MainLayout from "../layouts/MainLayout"
import { MatchPage } from '../pages'

function App() {
  return (
    <div className="app">
          <Routes>
            <Route path={'/'} element={
                <MainLayout>
                    <MatchPage />
                </MainLayout>
            } />
          </Routes>
        <ToastContainer/>
    </div>
  )
}

export default App
